import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './profile-list-carousel.component.scss';
import Slider from '../slider/slider.component';
var ProfileListCarousel = /** @class */ (function (_super) {
    tslib_1.__extends(ProfileListCarousel, _super);
    function ProfileListCarousel(element) {
        return _super.call(this, element) || this;
    }
    ProfileListCarousel.prototype.init = function () {
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.sliderConfig = {
            slidesPerView: 1,
            spaceBetween: 0,
            initialSlide: 0,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    ProfileListCarousel.prototype.bindEvents = function () { };
    return ProfileListCarousel;
}(Base));
export { ProfileListCarousel };



//////////////////
// WEBPACK FOOTER
// ./components/profile-list-carousel/profile-list-carousel.component.ts
// module id = 459
// module chunks = 0